// Settings
const popupSettings = {
    displayDuration: 10000, // Time popup stays visible (milliseconds)
    transitionDuration: 800, // Transition time for popup (milliseconds)
    interval: 45000, // Time interval between popups (milliseconds)
    popupWidth: '440px', // Popup width
    popupMaxWidth: '80vw', // Popup max width
    imageWidth: '50px', // Image width
    imageHeight: '50px', // Image height
    textFontSize: '13px', // Font size for text
    textLineHeight: '17px', // Line height for text
    productLinkMaxWidth: '100%' // Max width for product link
};

// Locations and Products data (already provided in the user's code)
const locations = [
    "New York", "Los Angeles", "Chicago", "Houston", "Phoenix", 
    "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Jose", 
    "Austin", "Jacksonville", "Fort Worth", "Columbus", "Charlotte", 
    "San Francisco", "Indianapolis", "Seattle", "Denver", "Washington", 
    "Boston", "El Paso", "Nashville", "Detroit", "Oklahoma City", 
    "Portland", "Las Vegas", "Memphis", "Louisville", "Baltimore", 
    "Milwaukee", "Albuquerque", "Tucson", "Fresno", "Mesa", 
    "Sacramento", "Atlanta", "Kansas City", "Colorado Springs", "Miami", 
    "Raleigh", "Omaha", "Long Beach", "Virginia Beach", "Oakland", 
    "Minneapolis", "Tulsa", "Arlington", "Tampa",
    "Wichita", "Bakersfield", "Aurora", "Anaheim", "Santa Ana", 
    "Riverside", "Corpus Christi", "Lexington", "Stockton", "Henderson", 
    "Saint Paul", "St. Louis", "Cincinnati", "Pittsburgh", "Greensboro", 
    "Anchorage", "Plano", "Lincoln", "Orlando", "Irvine", 
    "Newark", "Toledo", "Durham", "Chula Vista", "Fort Wayne", 
    "Jersey City", "St. Petersburg", "Laredo", "Madison", "Chandler", 
    "Lubbock", "Scottsdale", "Reno", "Buffalo", "Gilbert", 
    "Glendale", "North Las Vegas", "Winston-Salem", "Chesapeake", "Norfolk", 
    "Fremont", "Garland", "Irving", "Hialeah", "Richmond", 
    "Boise", "Spokane", "Baton Rouge", "Tacoma", "San Bernardino",
    "Huntsville", "Des Moines", "Salt Lake City", "Knoxville", "Birmingham", 
    "Grand Rapids", "Little Rock", "Augusta", "Mobile", "Newport News", 
    "Shreveport", "Tempe", "Yonkers", "Overland Park", "Tallahassee", 
    "Aurora", "McKinney", "Amarillo", "Glendale", "Huntington Beach", 
    "Montgomery", "Fayetteville", "Fontana", "Moreno Valley", "Oxnard"
];


const productsJustBought = [
    {
        name: "God's Masterpiece",
        url: "/products/gods-masterpiece",
        image_url: "//inspiritclothing.com/cdn/shop/files/10916049807352260837_2048_large.jpg?v=1716032524"
    },
    {
        name: "BIBLE - Basic Instructions Before Leaving Earth",
        url: "/products/bible-basic-instructions-before-leaving-earth",
        image_url: "//inspiritclothing.com/cdn/shop/files/696053644182529971_2048_large.jpg?v=1716032144"
    },
    {
        name: "FAITH - Forwarding All Issues To Heaven T- Shirt",
        url: "/products/faith-forwarding-all-issues-to-heaven-t-shirt",
        image_url: "//inspiritclothing.com/cdn/shop/files/5242108563634783875_2048_large.jpg?v=1716032768"
    },
    {
        name: "Let Your Light Shine T-Shirt",
        url: "/products/let-your-light-shine-t-shirt",
        image_url: "//inspiritclothing.com/cdn/shop/files/17956846872001461311_2048_large.jpg?v=1716033019"
    },
    {
        name: "Let Go and Let God T-Shirt",
        url: "/products/let-go-and-let-god-t-shirt",
        image_url: "//inspiritclothing.com/cdn/shop/files/14901227771583967134_2048_large.jpg?v=1716033248"
    },
    {
        name: "Faith 100% - Short Sleeve Tee",
        url: "/products/faith-100-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/15085001430028316824_2048_large.jpg?v=1716825756"
    },
    {
        name: "Pray More Worry Less - Short Sleeve Tee",
        url: "/products/pray-more-worry-less-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/3568422842149311891_2048_large.jpg?v=1716825805"
    },
    {
        name: "Rooted And Grounded - Short Sleeve Tee",
        url: "/products/rooted-and-grounded-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/3028321803144693668_2048_large.jpg?v=1718484769"
    },
    {
        name: "Awesome Believer Checklist - Short Sleeve Tee",
        url: "/products/awesome-believer-checklist-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/16203764377310201582_2048_large.jpg?v=1716826802"
    },
    {
        name: "Forgiven - Short Sleeve Tee",
        url: "/products/forgiven-short-sleeve-tee-3",
        image_url: "//inspiritclothing.com/cdn/shop/files/14757632925458318751_2048_large.jpg?v=1718483902"
    },
    {
        name: "Walking By Faith - Short Sleeve Tee",
        url: "/products/walking-by-faith-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/4193771300696445399_2048_large.jpg?v=1718411945"
    },
    {
        name: "Forgiven - Short Sleeve Tee",
        url: "/products/forgiven-short-sleeve-tee-4",
        image_url: "//inspiritclothing.com/cdn/shop/files/15445059818619019646_2048_large.jpg?v=1718485610"
    },
    {
        name: "His Grace is Enough - Short Sleeve Tee",
        url: "/products/his-grace-is-enough-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/3434877379804745484_2048_large.jpg?v=1716826459"
    },
    {
        name: "Inhale Blessing, Exhale Fear - Short Sleeve Tee",
        url: "/products/inhale-blessing-exhale-fear-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/8678377456641934744_2048_large.jpg?v=1716830473"
    },
    {
        name: "Grace Upon Grace - Short Sleeve Tee",
        url: "/products/grace-upon-grace-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/2344641869905368907_2048_large.jpg?v=1716832468"
    },
    {
        name: "Walk by Faith - Short Sleeve Tee",
        url: "/products/walk-by-faith-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/14824146173994364699_2048_large.jpg?v=1716832703"
    },
    {
        name: "Psalm 91 Warrior - Short Sleeve Tee",
        url: "/products/psalm-91-warrior-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/7505307260612776544_2048_large.jpg?v=1716833032"
    },
    {
        name: "Grace Upon Grace - Short Sleeve Tee",
        url: "/products/grace-upon-grace-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/16977967166239784617_2048_large.jpg?v=1716833314"
    },
    {
        name: "Love Like Jesus - Short Sleeve Tee",
        url: "/products/love-like-jesus-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/6554615128715072743_2048_large.jpg?v=1716833714"
    },
    {
        name: "Walk by Faith - Short Sleeve Tee",
        url: "/products/walk-by-faith-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/14771844164575346693_2048_large.jpg?v=1716833889"
    },
    {
        name: "Worship in Spirit - Short Sleeve Tee",
        url: "/products/worship-in-spirit-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/8103565265565534102_2048_large.jpg?v=1716834175"
    },
    {
        name: "Worship in Spirit and Truth - Short Sleeve Tee",
        url: "/products/worship-in-spirit-and-truth-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/384433708926800032_2048_large.jpg?v=1716834472"
    },
    {
        name: "Love Like Jesus - Short Sleeve Tee",
        url: "/products/love-like-jesus-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/5677850678528293549_2048_large.jpg?v=1716834729"
    },
    {
        name: "He Is Risen - Short Sleeve Tee",
        url: "/products/he-is-risen-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/9041424104462792073_2048_large.jpg?v=1716905416"
    },
    {
        name: "Forgiven - Short Sleeve Tee",
        url: "/products/forgiven-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/6905697355036132790_2048_large.jpg?v=1718412094"
    },
    {
        name: "Forgiven - Short Sleeve Tee",
        url: "/products/forgiven-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/11166236039850242540_2048_large.jpg?v=1718412248"
    },
    {
        name: "Jesus Is King - Short Sleeve Tee",
        url: "/products/jesus-is-king-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/16932563214878147159_2048_large.jpg?v=1718413905"
    },
    {
        name: "Forgiven - Short Sleeve Tee",
        url: "/products/forgiven-short-sleeve-tee-2",
        image_url: "//inspiritclothing.com/cdn/shop/files/17875446361952742800_2048_large.jpg?v=1718414903"
    },
    {
        name: "Set Free - Short Sleeve Tee",
        url: "/products/set-free-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/883305788070517483_2048_large.jpg?v=1718415587"
    },
    {
        name: "Walking By Faith - Short Sleeve Tee",
        url: "/products/walking-by-faith-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/6175692050431731743_2048_large.jpg?v=1718415653"
    },
    {
        name: "Amen - Short Sleeve Tee",
        url: "/products/amen-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/424436674092642273_2048_large.jpg?v=1718415795"
    },
    {
        name: "Jesus Won - Short Sleeve Tee",
        url: "/products/jesus-won-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/17242544782409858425_2048_large.jpg?v=1718415444"
    },
    {
        name: "John 3:16 - Short Sleeve Tee",
        url: "/products/john-3-16-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/5260590712707916313_2048_large.jpg?v=1718416494"
    },
    {
        name: "Jesus Won - Short Sleeve Tee",
        url: "/products/jesus-won-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/8420066608191061278_2048_large.jpg?v=1718416116"
    },
    {
        name: "Jesus Won - Short Sleeve Tee",
        url: "/products/jesus-won-short-sleeve-tee-2",
        image_url: "//inspiritclothing.com/cdn/shop/files/2176758631885460214_2048_large.jpg?v=1718416562"
    },
    {
        name: "Jesus Won - Short Sleeve Tee",
        url: "/products/jesus-won-short-sleeve-tee-3",
        image_url: "//inspiritclothing.com/cdn/shop/files/11106246616882658026_2048_large.jpg?v=1718416695"
    },
    {
        name: "God Got Me - Short Sleeve Tee",
        url: "/products/god-got-me-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/5791869722728537508_2048_large.jpg?v=1718416800"
    },
    {
        name: "Jesus Won - Short Sleeve Tee",
        url: "/products/jesus-won-short-sleeve-tee-4",
        image_url: "//inspiritclothing.com/cdn/shop/files/6830180588519701013_2048_large.jpg?v=1718416920"
    },
    {
        name: "Pray More - Short Sleeve Tee",
        url: "/products/pray-more-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/1436773917530630090_2048_large.jpg?v=1718417067"
    },
    {
        name: "Faith - Short Sleeve Tee",
        url: "/products/faith-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/7745391243494581088_2048_large.jpg?v=1718417128"
    },
    {
        name: "Faith It Till You Make It - Short Sleeve Tee",
        url: "/products/faith-it-till-you-make-it-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/14599357207993251246_2048_large.jpg?v=1718483272"
    },
    {
        name: "Hope - Short Sleeve Tee",
        url: "/products/hope-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/8585080245098732919_2048_large.jpg?v=1718483708"
    },
    {
        name: "Believe In You - Short Sleeve Tee",
        url: "/products/believe-in-you-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/15265121842937134184_2048_large.jpg?v=1718484036"
    },
    {
        name: "Faith - Short Sleeve Tee",
        url: "/products/faith-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/9609531140719466319_2048_large.jpg?v=1718484171"
    },
    {
        name: "Faith It Till You Make It - Short Sleeve Tee",
        url: "/products/faith-it-till-you-make-it-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/13626739673308155945_2048_large.jpg?v=1718484993"
    },
    {
        name: "God First - Short Sleeve Tee",
        url: "/products/god-first-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/14881501937497863004_2048_large.jpg?v=1718484485"
    },
    {
        name: "Faith It Till You Make It - Short Sleeve Tee",
        url: "/products/faith-it-till-you-make-it-short-sleeve-tee-2",
        image_url: "//inspiritclothing.com/cdn/shop/files/5785830682138933466_2048_large.jpg?v=1718484603"
    },
    {
        name: "Amen - Short Sleeve Tee",
        url: "/products/amen-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/12223395648341965473_2048_large.jpg?v=1718485147"
    },
    {
        name: "God First - Short Sleeve Tee",
        url: "/products/god-first-short-sleeve-tee-1",
        image_url: "//inspiritclothing.com/cdn/shop/files/8215890871799192705_2048_large.jpg?v=1718485473"
    },
    {
        name: "Be The Light - Short Sleeve Tee",
        url: "/products/be-the-light-short-sleeve-tee",
        image_url: "//inspiritclothing.com/cdn/shop/files/15491806572233923659_2048_large.jpg?v=1718485950"
    }
];
;

function createPopup() {
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const randomProduct = productsJustBought[Math.floor(Math.random() * productsJustBought.length)];

    const popup = document.createElement('div');
    popup.style.position = 'fixed';
    popup.style.bottom = '15px';
    popup.style.left = '15px';
    popup.style.width = popupSettings.popupWidth;
    popup.style.maxWidth = popupSettings.popupMaxWidth;
    popup.style.backgroundColor = 'white';
    popup.style.padding = '10px';
    popup.style.borderRadius = '5px';
    popup.style.boxShadow = '0 0 10px rgba(0,0,0,0.1)';
    popup.style.display = 'flex';
    popup.style.alignItems = 'center';
    popup.style.transition = `transform ${popupSettings.transitionDuration}ms ease, opacity ${popupSettings.transitionDuration}ms ease`;
    popup.style.transform = 'translateY(100%)';
    popup.style.opacity = '0';
    popup.style.zIndex = "999999"

    const img = document.createElement('img');
    img.src = randomProduct.image_url;
    img.style.width = popupSettings.imageWidth;
    img.style.height = popupSettings.imageHeight;
    img.style.borderRadius = '5px';
    img.style.marginRight = '10px';

    const textContainer = document.createElement('div');
    textContainer.style.flex = '1';
    textContainer.style.overflow = 'hidden';

    const text = document.createElement('p');
    text.style.margin = '0';
    text.style.fontSize = popupSettings.textFontSize;
    text.style.lineHeight = popupSettings.textLineHeight;
    text.innerHTML = `Someone in ${randomLocation} just purchased 🙏<br>`;

    const productLink = document.createElement('a');
    productLink.href = randomProduct.url;
    productLink.textContent = randomProduct.name;
    productLink.style.whiteSpace = 'nowrap';
    productLink.style.overflow = 'hidden';
    productLink.style.textOverflow = 'ellipsis';
    productLink.style.display = 'inline-block';
    productLink.style.maxWidth = popupSettings.productLinkMaxWidth;

    text.appendChild(productLink);
    textContainer.appendChild(text);
    popup.appendChild(img);
    popup.appendChild(textContainer);

    document.body.appendChild(popup);

    setTimeout(() => {
        popup.style.transform = 'translateY(0)';
        popup.style.opacity = '1';
    }, popupSettings.transitionDuration);

    setTimeout(() => {
        popup.style.transform = 'translateY(100%)';
        popup.style.opacity = '0';
    }, popupSettings.displayDuration + popupSettings.transitionDuration);
  

    setTimeout(() => {
        popup.remove();
    }, popupSettings.displayDuration + popupSettings.transitionDuration * 2);


    // Store the current time when the popup is shown
    localStorage.setItem('lastPopupTime', Date.now());
}

function someoneBought() {
    // Check the last time a popup was shown
    const lastPopupTime = localStorage.getItem('lastPopupTime');
    const now = Date.now();

    if (!lastPopupTime || now - lastPopupTime >= popupSettings.interval) {
        createPopup();
    }

    setInterval(() => {
        const lastPopupTime = localStorage.getItem('lastPopupTime');
        const now = Date.now();

        if (!lastPopupTime || now - lastPopupTime >= popupSettings.interval) {
            createPopup();
        }
    }, popupSettings.interval);
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(someoneBought, 3000);
});
